__turbopack_context__.v({
  "className": "notosansthai_7631f8d7-module__SkzYWG__className",
  "variable": "notosansthai_7631f8d7-module__SkzYWG__variable",
});
